import styled from 'styled-components';
import { DialogProps } from './dialog.types';

export const Image = styled.img`
  width: 100%;
  height: 130px;
  object-fit: cover;
  border-radius: ${({ theme: { radius } }) => radius.sm};
`;

export const Container = styled.div<{ type: DialogProps['type'] }>`
  width: ${({ type }) => (type === 'waiting' ? 'min-content' : '400px')};
  border-radius: 16px;
  padding: ${({ type }) => (type === 'waiting' ? '28px 24px' : '20px')};
  gap: 20px;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme: { color } }) => color.ui7};
  box-shadow: ${({ theme: { shadows } }) => shadows.outerShadow};
  box-sizing: border-box;
`;

export const HeaderContainer = styled.div`
  width: 100%;
  border-bottom: 1px solid ${({ theme: { color } }) => color.ui4};
`;

export const Header = styled.div`
  width: 100%;
  margin-bottom: 12px;
  ${({ theme: { font } }) => font.t1}
  color: ${({ theme: { color } }) => color.ui2};
  text-align: center;
`;

export const ContentWrapper = styled.div<{ type: DialogProps['type']; size: DialogProps['size'] }>`
  ${({ theme: { font }, type, size }) =>
    type === 'waiting' ? font.t3 : size === 'sm' ? font.t4 : font.t2}
  display: flex;
  align-items: center;
  gap: ${({ type }) => (type === 'waiting' ? '12px' : 0)};
  white-space: ${({ type }) => (type === 'waiting' ? 'nowrap' : 'normal')};
`;

export const ButtonContainer = styled.div<{ size: DialogProps['size'] }>`
  width: 100%;
  display: flex;
  gap: 12px;

  & > * {
    width: 100%;
    height: ${({ size }) => (size === 'sm' ? '28px' : '32px')};
    justify-content: center;
    pointer-events: inherit;
    ${({ theme: { font }, size }) => (size === 'sm' ? font.t5 : font.t3)}
  }
`;
